import React, {useState} from "react";
import keys from "../../translations/keys";
import {useTranslation} from "react-i18next";
import useDllFiles from "../../Hooks/useDllFiles";

const StartDotaBlock = () => {
    const [isDownloadMenuOpen, setDownloadMenuOpen] = useState(false);
    const {t} = useTranslation();
    const {downloadClientFile, isLoading: isDownloading} = useDllFiles();

    return <div className="start-dota-block">
        <div className="start-dota-block--buttons">
            <div className="download-split-button">
                <button type="button" className="download-split-button--main"
                        disabled={isDownloading} onClick={() => downloadClientFile()}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 3V15M12 15L7 10M12 15L17 10M5 21H19"
                              stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                              strokeLinejoin="round"/>
                    </svg>
                    {t(keys.mainPage.downloadClient)}
                </button>
                <button type="button"
                        className="download-split-button--toggle"
                        aria-label={t(keys.mainPage.downloadMirrors)}
                        aria-expanded={isDownloadMenuOpen}
                        onClick={() => setDownloadMenuOpen(!isDownloadMenuOpen)}>
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                {isDownloadMenuOpen && <div className="download-split-button--menu">
                    <button type="button" disabled={isDownloading}
                            onClick={() => {
                                setDownloadMenuOpen(false);
                                downloadClientFile("http://apitr.divine.wtf/");
                            }}>
                        {t(keys.mainPage.downloadTurkey)}
                    </button>
                    <button type="button" disabled={isDownloading}
                            onClick={() => {
                                setDownloadMenuOpen(false);
                                downloadClientFile("http://apiru.divine.wtf/");
                            }}>
                        {t(keys.mainPage.downloadRussia)}
                    </button>
                </div>}
            </div>
        </div>
    </div>
}

export default StartDotaBlock;
